import React from 'react'
import PropTypes from 'prop-types'

import { AppointmentStatus } from 'lib/constants'

const statusName = appointment => {
  const { appointmentStatus: status } = appointment
  switch (status) {
    case AppointmentStatus.Closed: return 'Fechada'
    case AppointmentStatus.ReservedPaymentPending: return 'Aguardando Pagamento'
    case AppointmentStatus.ReservedPaymentDone: return 'Pagamento Realizado'
    case AppointmentStatus.Completed: return 'Consulta Realizada'
    case AppointmentStatus.CancelledByProfessional: return 'Cancelada pelo Profissional'
    case AppointmentStatus.CancelledByClient: return 'Cancelada pelo Cliente'
    case AppointmentStatus.CancelledByAdmin: return 'Cancelada pela VirtualClin'
    default: return 'Disponível'
  }
}

const AppointmentStatusLabel = ({ appointment }) => (
  <span>{statusName(appointment)}</span>
)

AppointmentStatusLabel.propTypes = {
  appointment: PropTypes.object.isRequired
}
export default AppointmentStatusLabel



// WEBPACK FOOTER //
// ./src/components/AppointmentStatusLabel/index.js